module.exports = __webpack_public_path__ + "img/arrived_status.f281b00c.svg";